import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./Testimonials.css";

const Testimonials = () => {
  const images = [
    "assets/img/testimonials/1.png",
    "assets/img/testimonials/2.png",
    "assets/img/testimonials/3.png",
    "assets/img/testimonials/4.png",
    "assets/img/testimonials/5.png",
    "assets/img/testimonials/6.png",
    "assets/img/testimonials/7.png",
    "assets/img/testimonials/8.png",
    "assets/img/testimonials/9.png",
    "assets/img/testimonials/10.png",
    "assets/img/testimonials/11.png",
  ];

  const videos = [
    "assets/img/testimonials/1.mp4",
    "assets/img/testimonials/2.mp4",
    "assets/img/testimonials/3.mp4",
    "assets/img/testimonials/4.mp4",
    "assets/img/testimonials/5.mp4",
    "assets/img/testimonials/6.mp4",
    "assets/img/testimonials/7.mp4",
    "assets/img/testimonials/8.mp4",
  ];

  return (
    <section id="testimonials" className="testimonials section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Testimonials</h2>
        <p>What people have to say about us.</p>
      </div>

      {/* 🖼️ Image Slider */}
      <div className="testimonial-slider">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={3}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop={true}
          breakpoints={{
            1024: { slidesPerView: 3 },
            600: { slidesPerView: 2 },
            0: { slidesPerView: 1 },
          }}
        >
          {images.map((imgPath, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-slide">
                <img
                  src={imgPath}
                  alt={`Testimonial ${index + 1}`}
                  className="testimonial-img"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* 🎬 Video Slider */}
      <div
        className="testimonial-slider video-slider"
        style={{ marginTop: "60px" }}
      >
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={30}
          slidesPerView={2} // 🎯 now 3 per slide
          navigation
          pagination={{ clickable: true }}
          loop={true}
          breakpoints={{
            1024: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            0: { slidesPerView: 1 },
          }}
        >
          {videos.map((videoPath, index) => (
            <SwiperSlide key={`video-${index}`}>
              <div
                className="testimonial-slide video-wrapper"
                onClick={(e) => e.stopPropagation()}
              >
                <video
                  className="testimonial-video"
                  controls
                  preload="metadata"
                  playsInline
                  onPlay={(e) => {
                    // Pause all other videos when one starts playing
                    document
                      .querySelectorAll(".testimonial-video")
                      .forEach((vid) => {
                        if (vid !== e.target) vid.pause();
                      });
                  }}
                >
                  <source src={videoPath} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;
